import { styled } from 'styled-components'
import COLORS from '@web-ui-kit/colors'

export const ToggleContainer = styled.button`
  align-items: center;
  background: none;
  border: 0;
  color: ${COLORS.BLACK};
  cursor: pointer;
  display: inline-flex;
  gap: 0.313rem;
  margin: 0 1rem;
  padding: 0;
`
